import { Link } from 'react-router-dom';
import { LayoutGrid, Plus } from 'lucide-react';
import type { Application, CurrentUser } from '@electrodavisan/shared';
import { ROUTES } from '../../app/config';
import { Button, EmptyState, SkeletonCards } from '../../components/ui';
import { ApplicationCard } from './ApplicationCard';

/**
 * Rejilla del launcher con su estado vacio.
 *
 * La primera instalacion no tiene ninguna aplicacion vinculada y esto es lo
 * normal, no un error: el vacio esta disenado, y no se inventan aplicaciones
 * de ejemplo para rellenarlo.
 */
export function ApplicationsGrid({
  applications,
  isLoading,
  user,
}: {
  applications: Application[] | undefined;
  isLoading: boolean;
  user: CurrentUser | undefined;
}): JSX.Element {
  if (isLoading) {
    return <SkeletonCards count={3} />;
  }

  if (!applications || applications.length === 0) {
    return (
      <EmptyState
        icon={<LayoutGrid className="h-6 w-6" aria-hidden />}
        title="Todavia no hay aplicaciones vinculadas al Ecosystem"
        description={
          user?.isAdmin
            ? 'Registra la primera aplicacion para comenzar a construir el ecosistema.'
            : 'Cuando se te autorice el acceso a una aplicacion, aparecera aqui automaticamente.'
        }
        action={
          user?.isAdmin ? (
            <Link to={ROUTES.adminApps}>
              <Button leftIcon={<Plus className="h-4 w-4" aria-hidden />}>
                Registrar aplicacion
              </Button>
            </Link>
          ) : null
        }
      />
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {applications.map((application) => (
        <ApplicationCard key={application.id} application={application} />
      ))}
    </div>
  );
}
